import { useAppState } from '../useAppState';

export const useUsersCache = () => {
  const { usersCache } = useAppState();

  return usersCache;
};
